import React, { memo, useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import Notification from 'rc-notification';
import { confirmAlert } from "react-confirm-alert";

import { getConditionalOrderBook, executeCancelConditionalOrder } from '../../helpers/apiOrderHelper';

import { formatNumber_N1, priceToNumber, camelCaseObject } from '../../helpers/utils';

let notification = null;
Notification.newInstance({
    closable: true,
    duration: 3,
    style: {
        'top': 50, 
        right: 20,
        color: '#000',
    }
}, (n) => notification = n);

const timeReloadData = 10;

export default memo(function ODRConditionalOrderBook(props) {

    const { accTno } = props;

    const ref_AccTno = useRef(null);
    const ref_TransPass = useRef(null);

    const [executingOrder, setExecutingOrder] = useState(false); 
    const [orderBook, setOrderBook] = useState([]);
    const [counter, setCounter] = useState(timeReloadData);
    
    const { t } = useTranslation();
    const language = useSelector(state => state.gShared.language);
    const token = useSelector(state => state.gUser.token);

    //
    const _getOrderBook = () => {
        const _getAccTno = accTno;
        const _objData = {
            ticket: token,
            accTno: _getAccTno,
            StockSymbol: '',
            Status: "'0','1','5','9'",
            FromDate: '01/01/2000',
            ToDate: '31/12/9999'
        }
        //
        getConditionalOrderBook(_objData).then(function (res) {
            if(res.status === 200) {
                if(_getAccTno === ref_AccTno.current) {
                    const _data = camelCaseObject(res.data);
                    setOrderBook(_data.model);
                }
            }
            else {
                console.log(res);
            }
        })
        .catch(function (err) {
            console.log(err);
        });
    }

    const _setInputTransPassValue = (value) => {
        if(ref_TransPass.current) {
            ref_TransPass.current.value = value;
        }
        else {
            setTimeout(function() {
                _setInputTransPassValue(value);
            }, 250);
        }
    }

    const _handleInputTransPassFocus = () => {
        if(ref_TransPass.current) {
            ref_TransPass.current.removeAttribute('readonly');
        }
    }

    const _handleInputTransPassBlur = () => {
        if(ref_TransPass.current) {
            ref_TransPass.current.setAttribute('readonly', true);
        }
    }

    const _showConfirmCancelOrder = (orderData) => {
        try {
            confirmAlert({
                closeOnEscape: true,
                closeOnClickOutside: true,
                customUI: ({ onClose }) => {
                    return (
                        <div className="react-confirm-alert">
                            <div className="react-confirm-alert-body">
                                <h2 className='text-center'>{t('xacNhanHuyLenh')}</h2>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{width: '30%'}}>{t('taiKhoan')}:</td>
                                            <td><b>{orderData.aFACCTNO}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('loaiLenh')}:</td>
                                            <td className={orderData.eXECTYPE === "NB" ? "clr-up" : orderData.eXECTYPE === "NS" ? "clr-down" : ""}>
                                                <b>{(orderData.eXECTYPE === "NB" ? t('mua') : orderData.eXECTYPE === "NS" ? t('ban') : "")}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{t('maCK')}:</td>
                                            <td><b>{orderData.sYMBOL}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('gia')}:</td>
                                            <td><b>{orderData.sENDPRICE}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('khoiLuong')}:</td>
                                            <td><b>{formatNumber_N1(orderData.oRDERQTTY)}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('hieuLucDenNgay')}:</td>
                                            <td><b>{orderData.tODATE}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('matKhauGD')}:</td>
                                            <td>
                                                <input className='input-default' style={{margin: 0, width: '100%'}} type={"password"} readOnly maxLength={20} ref={ref_TransPass} onFocus={_handleInputTransPassFocus} onBlur={_handleInputTransPassBlur} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='text-center' style={{marginTop: 10}}>
                                    <button type='button' className='btn-sv' onClick={() => {
                                        _executeCancelOrder(orderData.oRDERID, orderData.sYMBOL, onClose);
                                    }}>{t('xacNhan')}</button>
                                    <button type='button' className='btn-ex' onClick={() => {
                                        setExecutingOrder(false);
                                        onClose();
                                    }}>{t('huy')}</button>
                                </div>
                            </div>
                        </div>
                    )
                }
            });
        } catch (error) {
            console.log(error);
        }
    }

    const _executeCancelOrder = (orderId, symbol, callback) => {
        if(executingOrder) {
            return;
        }
        setExecutingOrder(true);

        try {
            executeCancelConditionalOrder({
                ticket: token,
                orderId: orderId,
                Symbol: symbol,
                // FromAddress: 'OB',
                passTransfer: ref_TransPass.current?.value ?? '',
            }).then(function (res) {
                if(res.status === 200) {
                    const _data = camelCaseObject(res.data);
                    if(_data.code === 0) {
                        notification.notice({
                            content: t('huyLenhThanhCong'),
                            style: {
                                color: 'green',
                            }
                        });
                        //
                        _getOrderBook();
                        if(callback) {
                            callback();
                        }
                    }
                    else {
                        notification.notice({
                            content: <span>{_data.msg}</span>,
                            style: {
                                color: 'red',
                            }
                        });
                    }
                }
                else {
                    console.log(res);
                }
                //
                setExecutingOrder(false);
            })
            .catch(function (err) {
                setExecutingOrder(false);
                if(callback) {
                    callback();
                }
                console.log(err);
                notification.notice({
                    content: 'Có lỗi xảy ra',
                    style: {
                        color: 'red',
                    }
                });
            });          
        } catch (error) {
            console.log(error);
            setExecutingOrder(false);
            if(callback) {
                callback();
            }
        }
    }

    //
    useEffect(() => {
        ref_AccTno.current = accTno;
        _getOrderBook();
    }, [accTno]);

    useEffect(() => {
        if(counter <= 0) {
            setCounter(timeReloadData);
            _getOrderBook();
        }
    }, [counter]);

    useEffect(() => {
        const _timerId = setInterval(() => {
            setCounter(o => o-1);
        }, 1000);

        return () => {
            if(_timerId > 0) {
                clearInterval(_timerId);
            }
        }; 
    }, []);
    
    //
    return ( 
        <table className="table-ck">
            <thead>
                <tr>
                    <th>{t('side')}</th>
                    <th>{t('maCK')}</th>
                    <th className='text-right'>{t('kl')}</th>
                    <th className='text-right'>{t('gia')}</th>
                    <th className='text-right'>{t('hieuLucDenNgay')}</th>
                    <th className='text-right'>{t('trangThai')}</th>
                    <th className='text-right'>{t('chucNang')}</th>
                </tr>
            </thead>
            <tbody>
            {orderBook && orderBook.map((item, index) => {
                // console.log(item);
                // aFACCTNO: "0001001242MG"
                // eXECTYPE: "NB"
                // eXECUTEPRICE: 0
                // iS_APPROVE: 0
                // iS_CANCEL: 1
                // oRDERID: "20220214000000695811"
                // oRDERQTTY: 1100
                // oSMARTTYPE: "Lệnh trước ngày"
                // oSMARTTYPE1: "FUTURE"
                // pRICECUTLOSS: 0
                // pRICEPROFIT: 0
                // pRICETYPE: "LO"
                // sELLCUTLOSSES: "Không"
                // sELLPROFIT: "Không"
                // sENDPRICE: 16.1
                // sTATUS: "Được ghi lại"
                // sYMBOL: "ACB"
                // tODATE: "29/07/2021"
                // vIA: "Trực tuyến"
                
                return (
                    <tr key={index}>
                        <td className={item.eXECTYPE === "NB" ? "clr-up" : item.eXECTYPE === "NS" ? "clr-down" : ""}>{(item.eXECTYPE === "NB" ? t('sideMua') : item.eXECTYPE === "NS" ? t('sideBan') : "")}</td>
                        <td>{item.sYMBOL}</td>
                        <td className='text-right'>{formatNumber_N1(item.oRDERQTTY)}</td>
                        <td className='text-right'>{item.sENDPRICE}</td>
                        <td className='break-word'>{item.tODATE}</td>
                        <td>{item.sTATUS}</td>
                        <td className='text-left'>
                            {item.iS_CANCEL && item.iS_CANCEL === 1 ? (
                                <span className='btn-icon clr-down' title='Cancel' onClick={() => _showConfirmCancelOrder(item)}>
                                    <img src="/static/img/icon/icon-trash.svg" alt="img" />
                                </span>
                            ) : null}
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </table> 
    )
})
